module.exports = __webpack_public_path__ + "img/funding-rate.2eb6835c.jpg";